import Header from "../src/local/Header"
import styles from '../styles/Onkormanyzat.module.css'
import { useTheme, useMediaQuery } from '@mui/material';
import theme from "./api/theme"

export default function Onkormanyzat() {
	const theme = useTheme();
	const largeScreen = useMediaQuery(theme.breakpoints.up('md'));


	return (
		<div>
			<div className={styles.main}>
				<Header />
				<div style={{ height: "4rem" }} />
			</div>
			<div className={styles.box}>
				<h2>Csatlakozzon ön is a rendkívül kedvező árú HolmiApp szolgáltatáshoz.</h2>
				
				2020 Decemberétől, elérhető szolgáltatásunk az alábbi modulokkal:
				
				<ul>
					<li>
						<u>Hírek</u>: Azonnali információk push üzenet lehetőséggel.
						<br /><br />
						<i>Megjeleníthető elemek</i>: címsor, rövid ismertető, leírás, képek, videók, telefon, webes linkek, térképen megjeleníthető helyszín, e-mail
					</li>
					<li>
						<u>Információk</u>: Modulunk alkalmas, ritkábban változó információk - pl. intézmények, szervezetek, vállalkozások - struktúrált
						szerkezetben történő megjelenítésére.
						<br /><br />
						<i>Megjeleníthető elemek</i>: címsor, rövid ismertető, leírás, Képek, videók, telefon, webes linkek, térképen megjeleníthető helyszín, e-mail, nyitvatartási idő, telefonos elérhetőség
					</li>
					<li>
						<u>Események</u>: Események, rendezvények megjelenítése időpont alapján.
						<br /><br />
						<i>Megjeleníthető elemek</i>: időpontok szöveges mezővel, címsor, rövid ismertető, leírás, Képek, videók, telefon, webes linkek, térképen megjeleníthető helyszín, e-mail
					</li>
					<li>
						<u>Bejelentések</u>: Testre szabható bejelentési lehetőségek, amivel a lakosság az önkormányzat felé információt tud közölni. Az információ áramlása
						az önkormányzat részéről szabályozott, a beküldött tartalom a nyilvánosság számára, 
						az önkormányzat jóváhagyása után látható.
						Használatához a lakosság részéről Facebook vagy Google azonosítás szükséges. A bejelentésekre az önkormányzat
						válasz üzenetet, illetve válasz képet tud küldeni.
						<br /><br />
						<i>Megjeleníthető elemek</i>: leírás, képek, válasz képek, telefon, térképen megjeleníthető helyszín, e-mail
					</li>
				</ul>
				<h2>Miért érdemes hozzánk csatlakozni?</h2>


				Több milliós költség helyett minimális havidíjjal veheti igénybe szolgáltatásunkat. A HolmiApp-ot folyamatosan fejlesztjük, hogy minél jobban
				ki tudjuk szolgálni az önkormányzat igényeit.
				
				<br />
				<br />
				Várjuk önöket is, folyamatosan bővülő szolgáltatásunkba.
				<br />
				<br />
				Szolgáltatásunk tartalmazza:

				<ul>
					<li>
						Android applikáció
					</li>
					<li>
						IOS applikáció
					</li>
					<li>
						Webes megjelenítés
					</li>
					<li>
						Könnyen kezelhető webes adminisztrációs felület a tartalom kezeléséhez
					</li>
					<li>
						Szerver infrastruktúra és üzemeltetése. Szervereink szerver hotelban üzemelnek, ahol a szabványoknak megfelelő maximális
						rendelkezésre állást biztosítják (elektromos hálózat, backup, klimatizáció, DDOS elleni védelem, internet elérés)
					</li>
					<li>
						Folyamatos fejlesztés, funkció bővítés és hibajavítás a visszajelzések alapján.
					</li>
				</ul>

				<div className={styles.default}>
					<h2>Kérjük tekintse meg Üllő alpolgármesterének tájékoztatóját az applikációról</h2>
					<iframe
						title="Kérem tekintse meg Üllő alpolgármesterének tájékoztatóját az applikációról."
						width="100%"
						height={largeScreen ? "520px" : "208px"}
						src="https://www.youtube.com/embed/UL7nWng_m2M"
						frameBorder='0'
						allowFullScreen
						sandbox="allow-scripts allow-same-origin"
					>
					</iframe>
				</div>
				<div className={styles.default}>
					<h2>WTV Híradó HOLMIAPP Maglódon</h2>
					<iframe
						title="WTV Híradó HOLMIAPP Maglódon"
						width="100%"
						height={largeScreen ? "520px" : "208px"}
						src="https://www.youtube.com/embed/b4lB72LGXYo"
						frameBorder='0'
						allowFullScreen
						sandbox="allow-scripts allow-same-origin"
					>
					</iframe>
				</div>
				
				<h3>
					Elérhetőségünk: info (kukac) holmiapp (pont) hu
				</h3>
			</div>
		</div>
	)
}